import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { Link, useNavigate } from "react-router-dom";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Vehicle_renewal_status = () => {
  useAuthRedirect();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(
    localStorage.getItem("branch") || ""
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState(""); // Search term state
  const navigate = useNavigate();

  const canView  = hasPermission("Vehicle Renewal status", "view");

  // Fetch data based on selected branch
  useEffect(() => {
    if (selectedBranch) {
      axios
        .get(
          `https://rfs2.infraconsoft.net.in/api/vehicle_details_report_own?branch_code=${selectedBranch}`
        )
        .then((response) => {
          setData(response.data.vehicles);
          setFilteredData(response.data.vehicles);
        })
        .catch((error) => {
          console.error("Error fetching vehicles:", error);
        });
    }
  }, [selectedBranch]);

  const getRenewalStatus = (date) => {
    if (!date) return "-"; // If date is empty, return "-"

    const currentDate = new Date();
    const renewalDate = new Date(date);

    // Calculate the difference in days
    const differenceInDays = Math.ceil(
      (renewalDate - currentDate) / (1000 * 60 * 60 * 24)
    );

    if (differenceInDays <= 7 && differenceInDays >= 0) return "Renewal"; // Within 7 days
    if (differenceInDays < 0) return "Expired"; // Past date

    return "-"; // Default case
  };

  // Handle page change
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate indexes for pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  // Handle search filter
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    const filtered = data.filter((item) => {
      return (
        (item.vehicle_code &&
          item.vehicle_code
            .toLowerCase()
            .includes(e.target.value.toLowerCase())) ||
        (item.vehicle_name &&
          item.vehicle_name
            .toLowerCase()
            .includes(e.target.value.toLowerCase())) ||
        (item.vehicle_number &&
          item.vehicle_number
            .toLowerCase()
            .includes(e.target.value.toLowerCase()))
      );
    });
    setFilteredData(filtered);
    setCurrentPage(1); // Reset to first page on search
  };

  const handleSelection = (event) => {
    const value = event.target.value;
    if (value) {
      navigate("/vehicle_renewal_status_hire");
    }
  };

     if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">
            Own Vehicle Details - Renwal & Expired List
          </h2>
          <div>
            <Time />
          </div>
        </section>

        <div className="vehicle-class">
  <div>
    <p>Select your vehicle :</p>
          <select className="branch-select" onChange={handleSelection}>
            <option value="/own">Own Vehicle</option>
            <option value="/hire">Hire Vehicle</option>
          </select>
        </div>
          </div>


        
           <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by vehicleName"
            value={searchTerm}
            onChange={handleSearch}
            className="branch-select search-uni"
          />
        </div>

        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th> Vehicle Code</th>
                <th>Vehicle Name</th>
                <th>Vehicle Number</th>
                <th>IC Renewal Alert</th>
                <th>FC Renewal Alert</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              {currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>{item.vehicle_code}</td>
                    <td>{item.vehicle_name}</td>
                    <td>{item.vehicle_number}</td>
                    <td>{getRenewalStatus(item.renewal_date)}</td>
                    <td>{getRenewalStatus(item.fc_renewaldate)}</td>
                    <td>
                      <Link to={`/vehicle_details_view/${item.SlNo}`}>
                        Details
                      </Link>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Controls */}
        <div className="pagination">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          {[...Array(Math.ceil(filteredData.length / itemsPerPage))].map(
            (_, index) => (
              <button
                key={index}
                onClick={() => paginate(index + 1)}
                className={currentPage === index + 1 ? "active" : ""}
              >
                {index + 1}
              </button>
            )
          )}
          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={
              currentPage === Math.ceil(filteredData.length / itemsPerPage)
            }
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Vehicle_renewal_status;
